module.exports = __webpack_public_path__ + "img/datav_bg2.c8512bbf.png";